import { render } from "./Avicenter.vue?vue&type=template&id=7178ddfa"
import script from "./Avicenter.vue?vue&type=script&lang=js"
export * from "./Avicenter.vue?vue&type=script&lang=js"

import "./Avicenter.vue?vue&type=style&index=0&id=7178ddfa&lang=css"

import exportComponent from "/Volumes/LACIE/vueSites/yem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__